import React from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory } from "react-router-dom";
import { LoaderScreen } from '../../components/LoaderScreen';
import { useEffect, useState, createContext, useRef } from 'react';
import request from '../../../Helpers/API';
import { GetKey } from "../../../Helpers/GetKey";
import { GetMonthNameByNumber } from "../../Finanzas/Helper/GetMonthNameByNumber";
import Swal from "sweetalert2";
import FiltroDashboard from "../../Finanzas/Dashboard/FiltroDashboard";
import { useBox } from "../../Finanzas/Helper/useBox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import SaveIcon from '@mui/icons-material/Save';
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";

export const DescuentosNoTimbradosSection = ({ data }) => {
    const [descuentos, setDescuentos] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });


    useEffect(() => {
        setDescuentos(data)
    }, [data]);

    return (
        <div className="listado-fiscal-invoicemovimientos-container">
            <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
                <table>
                    <thead>
                        <tr>
                            {/* <th>
                                ID
                            </th> */}
                            <th>
                                Sucursal
                            </th>
                            <th>
                                <div>Departamento</div>
                            </th>
                            <th>
                                <div>Cuenta</div>
                            </th>
                            <th>
                                <div>Documento</div>
                            </th>
                            <th>
                                <div>Fecha</div>
                            </th>
                            <th>
                                <div>Importe</div>
                            </th>
                            <th>
                                <div>Serie Fiscal</div>
                            </th>
                            <th>
                                <div>Folio Fiscal</div>
                            </th>
                            <th>
                                <div>Tipo de Comprobante</div>
                            </th>
                            <th>
                                <div>Batch</div>
                            </th>
                            <th>
                                <div>UUID</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {descuentos.map((des) => (
                            <tr>
                                {/* <td className="ta-center">{des.idregistro}</td> */}
                                <td className="ta-center">{capitalizePalabras(des.sucursal)}</td>
                                <td className="ta-center">{capitalizePalabras(des.departamento)}</td>
                                <td className="ta-center">{des.cuenta}</td>
                                <td className="ta-center">{des.documento}</td>
                                <td className="ta-center">{new Date(des.fecha).toLocaleDateString("es-MX", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric"
                                })}</td>
                                <td className="ta-right">{FormatMoney(des.importe)}</td>
                                <td className="ta-center">{des.serie_fiscal}</td>
                                <td className="ta-center">{des.folio_fiscal}</td>
                                <td className="ta-center">{capitalizePalabras(des.tipoComprobante)}</td>
                                <td className="ta-center">{des.batch}</td>
                                <td className="ta-center">{des.uuid}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
